import { AddIcon, IconProps } from "@chakra-ui/icons";

export const SmAddIcon = ({ ...rest }: IconProps) => (
  <AddIcon w="14px" h="14px" {...rest} />
);
